import { CelloReferralLanding } from '@components/CelloReferralLanding';
import {
  CELLO_REFERRAL_DISCOUNT_PERCENT,
  getCelloReferralCodeFromQuery,
  getCelloReferrerNameFromQuery,
} from '@modules/cello-referral';
import { makePageTitle } from '@modules/page-title';
import type { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';

interface ReferralLandingPageProps {
  referralCode: string | null;
  referrerName: string | null;
}

const ReferralLandingPage: NextPage<ReferralLandingPageProps> = ({
  referralCode,
  referrerName,
}) => (
  <>
    <Head>
      <title>{makePageTitle(referralCode ? 'Your referral offer' : undefined)}</title>
      <meta
        name="description"
        content={`Digital business cards and AI contact capture. Referred users get ${CELLO_REFERRAL_DISCOUNT_PERCENT}% off Blinq.`}
      />
      <meta name="robots" content="noindex" />
    </Head>
    <CelloReferralLanding referralCode={referralCode} referrerName={referrerName} />
  </>
);

export const getServerSideProps: GetServerSideProps<ReferralLandingPageProps> = async ({
  query,
}) => ({
  props: {
    referralCode: getCelloReferralCodeFromQuery(query),
    referrerName: getCelloReferrerNameFromQuery(query),
  },
});

export default ReferralLandingPage;
